





class Auth {
  login(userData) {
    localStorage.setItem("userToken", userData.token);
    localStorage.setItem("userId", userData.userId);
    localStorage.setItem("fullName", userData.fullName);
    localStorage.setItem("email", userData.email);
    localStorage.setItem("userPermissions", JSON.stringify(userData.permissions || []));
    
    // Ensure we get the string "Admin" or "Staff"
    const role = userData.roles && userData.roles.length > 0 ? userData.roles[0] : "Staff";
    localStorage.setItem("role", role);
  }

  getRole() {
    return localStorage.getItem("role");
  }

  getFullName() {
    return localStorage.getItem("fullName") || "User";
  }

  getPermissions() {
    const perms = localStorage.getItem("userPermissions");
    return perms ? JSON.parse(perms) : [];
}
  logout() {
    localStorage.clear();
    window.location.href = "/";
  }
}
export default new Auth();